import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loading from '../Loading/Loading';

const PublicRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return <Loading />;  // (importer Loading si nécessaire)
    }

    if (isAuthenticated) {
        // Si l'utilisateur était en train d'accéder à une page spécifique avant
        const redirectPath = localStorage.getItem('redirectAfterLogin');
        if (redirectPath) {
            localStorage.removeItem('redirectAfterLogin');
            return <Navigate to={redirectPath} replace />;
        }
        
        // Sinon, redirection par défaut vers mon-compte
        return <Navigate to="/mon-compte" replace />;
    }
    
    return children;
};

export default PublicRoute;